// extracted by mini-css-extract-plugin
module.exports = {"detail":"video_detail_detail__2BkQh","description":"video_detail_description__3nW_r"};